//
// Copyright 2026 DXOS.org
//
import * as Context from 'effect/Context';
import * as Rpc from 'effect/rpc/Rpc';
import * as RpcGroup from 'effect/rpc/RpcGroup';
import { QueryAgentStatusResponseSchema, QueryEdgeStatusResponseSchema, } from './buf/proto/gen/dxos/client/services_pb.js';
import { bufMessage, serviceError } from './service-rpc.js';
/**
 * Effect RPC definitions for the EDGE agent service (formerly `dxos.client.services.EdgeAgentService`).
 * All methods take no payload; responses reuse the shared `QueryEdgeStatusResponse` /
 * `QueryAgentStatusResponse` proto types.
 */
export class Rpcs extends RpcGroup.make(Rpc.make('queryEdgeStatus', {
    success: bufMessage(QueryEdgeStatusResponseSchema),
    error: serviceError,
    stream: true,
}), Rpc.make('createAgent', {
    error: serviceError,
}), Rpc.make('queryAgentStatus', {
    success: bufMessage(QueryAgentStatusResponseSchema),
    error: serviceError,
    stream: true,
})).prefix('EdgeAgentService.') {
}
/**
 * Effect service tag for the `EdgeAgentService` RPC handlers.
 */
export class Tag extends Context.Service()('@dxos/protocols/rpc/EdgeAgentService') {
}
//# sourceMappingURL=EdgeAgentService.js.map